function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 4H3.00703C2.72599 4 2.4879 4.10275 2.29274 4.30826C2.09758 4.51377 2 4.76449 2 5.06042V18.783C2 19.0789 2.09758 19.3296 2.29274 19.5351C2.30348 19.5465 2.31432 19.5579 2.32527 19.5695C2.51323 19.7684 2.73209 20 2.99766 20H10L12 23L13.9906 20H20.993C21.2663 20 21.499 19.7547 21.6911 19.5521C21.6965 19.5464 21.7019 19.5408 21.7073 19.5351C21.9024 19.3296 22 19.0789 22 18.783V13H20V18.0141L13 18L12 20L11 18H4V6H10V4ZM10 9H6.00937V11H10V9ZM10 13H6L6.00468 15H14.0047L14 13H10Z",
  fill: "#00E2FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 7L17 11L24 3",
  stroke: "#00E2FF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIcoCommentIntFill = function SvgIcoCommentIntFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoCommentIntFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-comment-int-fill.c398ac87.svg";
export { ForwardRef as ReactComponent };